module.exports = __webpack_public_path__ + "static/media/whatsapp-people.a73bf5d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/whatsapp-people.png
// module id = 408
// module chunks = 0